export default __webpack_public_path__ + "7b9a4e9700a44ba52b6dd82616a521f4.png";